import { QueryClient } from "@tanstack/react-query";

/**
 * App-wide TanStack Query client — the data cache that removes the
 * navigation loading flashes: pages already visited render their cached
 * data instantly and revalidate in the background.
 *
 * Defaults tuned for this internal dashboard:
 * - staleTime 30s: navigating back within 30s reuses the cache without any
 *   network round-trip (the legacy behaviour refetched on every mount with
 *   `cache: "no-store"` — the source of the spinner flash).
 * - refetchOnWindowFocus off: legacy pages never refetched on focus.
 * - retry 1: one silent retry, then the page's error state.
 */
/** Each server render owns its cache; browser navigation shares one client. */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}

export const queryClient = createQueryClient();
